import { IPart } from "./Part";
import { BaseEntity, DefaultResponseWithData } from "./system";

export interface InvoiceResponse extends DefaultResponseWithData<IInvoice> { }

export interface IInvoice extends BaseEntity {
  status: InvoiceStatus;
  invoiceNumber: number;
  reference: string;
  invoiceDate: string;
  dueDate: string;
  invoiceTotal: number;
  amountPaid: number;
  paymentMethod: PaymentMethod;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressLine4: string;
  town: string;
  county: string;
  postcode: string;
  notes: string;
  deleted: string | null;
  accountId: string;
  // account: Account;
  items: IInvoiceItem[];
}

export interface IInvoiceItem extends BaseEntity {
  description: string;
  quantity: number;
  unitPrice: number;
  discount: string;
  accountCode: string;
  taxRate: string;
  notes: string;
  deleted: string | null;
  invoiceId: string;
  invoice: IInvoice;
  part: IPart | null;
  partId: string | null;
}

export enum InvoiceStatus {
  Draft,
  Approved,
  Paid,
  Credit
}

export enum PaymentMethod {
  Cash,
  Card,
  Ebay,
  Stripe
}